<form [formGroup]="form">
  <ng-container *ngIf="displayVetSearch">
    <app-search-preferred-vet (showEditPreferredVet)="handleVetChange($event)">
    </app-search-preferred-vet>
  </ng-container>

  <ng-container *ngIf="!displayVetSearch">
    <app-content-header
      text="Veterinarian"
      [showEdit]="!editMode"
      (editClicked)="enterEditMode()"
      firebase="dogProfile_editVetDetails"
    ></app-content-header>
    <input type="hidden" formControlName="vetId" />
    <div
      *ngIf="!editMode"
      formArrayName="vaccineArr"
      style="margin-bottom: 2.5rem"
    >
      <span *ngIf="!selectedVet">You have not selected a vet.</span>
      <div
        *ngIf="selectedVet?.id"
        [style.margin-bottom]="editMode ? '1.5rem' : '2.5rem'"
      >
        <span class="oswald primary" style="font-size: 1.125rem">{{
          selectedVet.practiceName
        }}</span>
        <br />
        <span
          class="lato bold teal"
          style="font-size: 1.125rem"
          *ngIf="selectedVet.address1"
          >{{ selectedVet.address1 }}</span
        >
        <br />
        <div *ngIf="selectedVet?.address2?.trim()">
          <span
            class="lato bold teal"
            style="font-size: 1.125rem"
            *ngIf="selectedVet.address2"
            >{{ selectedVet.address2?.trim() }}</span
          >
          <br />
        </div>
        <span
          class="lato teal"
          style="font-size: 0.813rem"
          *ngIf="selectedVet.city"
          >{{ selectedVet.city }}, {{ selectedVet.state }}
          {{ selectedVet.zipcode }}</span
        >
        <br />
        <img
          src="assets/svg/ico_phone_red.svg"
          alt="Phone Icon"
          height="16"
          class="mr-1"
          *ngIf="selectedVet.telephone"
        />
        <a
          class="link"
          *ngIf="selectedVet.telephone"
          [href]="'tel:' + selectedVet.telephone"
          >{{ selectedVet.telephone | mask: "(000) 000-0000" }}</a
        >
      </div>
    </div>

    <div *ngIf="editMode" class="no-gutters" style="margin-bottom: 2.5rem">
      <div
        *ngIf="selectedVet?.id"
        [style.margin-bottom]="editMode ? '1.5rem' : '2.5rem'"
      >
        <span class="oswald primary" style="font-size: 1.125rem">{{
          selectedVet.practiceName
        }}</span>
        <span
          class="lato bold teal"
          style="font-size: 1.125rem; display: block;"
          *ngIf="selectedVet.address1"
          >{{ selectedVet.address1 }}</span
        >
        <div *ngIf="selectedVet?.address2?.trim()">
          <span
            class="lato bold teal"
            style="font-size: 1.125rem"
            *ngIf="selectedVet.address2"
            >{{ selectedVet.address2?.trim() }}</span
          >
          <br />
        </div>
        <span
          class="lato teal"
          style="font-size: 0.813rem; display: block;"
          *ngIf="selectedVet.city"
          >{{ selectedVet.city }}, {{ selectedVet.state }}
          {{ selectedVet.zipcode }}</span
        >
        <img
          src="assets/svg/ico_phone_red.svg"
          alt="Phone Icon"
          height="16"
          class="mr-1"
          *ngIf="selectedVet.telephone"
        />
        <a
          class="link"
          *ngIf="selectedVet.telephone"
          [href]="'tel:' + selectedVet.telephone"
          >{{ selectedVet.telephone | mask: "(000) 000-0000" }}</a
        >
      </div>

      <div class="col-sm-9">
        <button
          type="button"
          class="btn btn-outline-danger btn-block"
          (click)="selectVet()"
        >
          Find your local vet
        </button>
      </div>
    </div>
    <app-content-header
      text="Vaccinations"
      [showEdit]="!editMode"
      (editClicked)="enterEditMode()"
      firebase="dogProfile_editVaccination"
    ></app-content-header>
    <div *ngIf="unverifiedDocuments>0" class="vaccine-notification">
      <img
        src="assets/svg/ico_mail.svg"
        alt="Search Icon"
        width="24"
      >
      <div *ngIf="unverifiedDocuments === 1"> You have {{unverifiedDocuments}} uploaded document pending review.</div>
      <div *ngIf="unverifiedDocuments > 1"> You have {{unverifiedDocuments}} uploaded documents pending review.</div>
    </div>
    <div
      *ngIf="!editMode"
      formArrayName="vaccineArr"
      style="margin-bottom: 2.5rem"
    >
      <span *ngIf="vaccineFormArray.length === 0">No records found.</span>
      <ng-container
        *ngFor="let vaccine of vaccineFormArray.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="mb-3">
          <span class="lato bold teal">{{ vaccine.get("name").value }}</span
          ><br />
          <span
            *ngIf="
              !vaccine.get('expiresOn').value && vaccine.get('required').value;
              else isExist
            "
            class="vaccine-warning"
            style="font-size: 0.875rem"
            >Vaccination is missing</span
          >
          <ng-template #isExist>
            <span
              [ngClass]="{ 'vaccine-warning': vaccine.get('isWarning').value }"
              style="font-size: 0.875rem"
              >{{
                vaccine.get("expDateText").value +
                  (vaccine.get("expiresOn").value | date)
              }}</span
            >
          </ng-template>
        </div>
      </ng-container>
      <div class="row no-gutters emergency-box">
        <div class="col-auto">
          <img
            src="../../../../assets/svg/ico_paw_print.svg"
            width="12"
            class="paw-print"
          />
        </div>
        <div class="col emergency-text">
          All Campers must have up-to-date Rabies, Distemper and Bordetella vaccinations.
          Additional vaccinations such as Canine Influenza may be required.
        </div>
      </div>
    </div>
    <ng-container *ngIf="editMode">
      <div class="my-4">
        <div
          *ngFor="let file of imgFileFormArray.controls; let i = index"
          class="image-tile-container mr-3"
        >
          <div
            class="image-tile"
            [style.backgroundImage]="'url(\'' + file.get('url').value + '\')'"
          ></div>
          <img
            src="assets/images/ico_delete-photo.png"
            alt="Delete image icon"
            class="delete-icon"
            (click)="removeImage(i)"
          />
        </div>
        <div class="image-tile-container mr-3">
          <input
            hidden
            type="file"
            multiple
            accept=".jpg, .jpeg, .png, .pdf"
            #uploader
            (change)="chooseFiles($event.target.files)"
          />
          <div
            class="image-tile add-icon"
            tabindex="0"
            (click)="uploader.click() && uploadVacc()"
            (keyup.enter)="uploader.click() && uploadVacc()"
          ></div>
        </div>
      </div>
    </ng-container>
    <app-content-header
      text="Allergies"
      [showEdit]="!editMode"
      (editClicked)="enterEditMode()"
      firebase="dogProfile_editAllergies"
    ></app-content-header>
    <div *ngIf="editMode" formArrayName="allergyArr">
      <ng-container
        *ngFor="let allergy of allergyFormArray.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="input-container d-flex pb-1" style="font-size: 1.25rem">
          <div style="flex: 1">
            <span class="lato bold title-red">{{ "Allergy " + (i + 1) }}</span>
          </div>
          <div
            class="icon-container trash"
            (click)="removeAllergy(i)"
            (keyup.enter)="removeAllergy(i)"
            tabindex="0"
          >
            <img
              src="assets/svg/ico_trash_can.svg"
              alt="Trash Can Icon"
              width="15"
            />
          </div>
        </div>
        <div class="dropdown input-container">
          <span class="input-label">Allergy Type</span>
          <mat-form-field class="input">
            <mat-select formControlName="attributeId">
              <mat-option
                *ngFor="let allergy of allergyTypeList"
                [value]="allergy.attributeId"
                >{{ allergy.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <span
            *ngIf="allergy.get('attributeId').errors?.required"
            class="error"
            >Please select an allergy type.</span
          >
        </div>
        <div class="input-container">
          <div class="d-flex">
            <div style="flex: 1">
              <span class="input-label">Allergy Description</span>
            </div>
          </div>
          <textarea
            type="text"
            class="input"
            rows="5"
            style="height: auto"
            formControlName="description"
          ></textarea>
          <span
            *ngIf="allergy.get('description').errors?.required"
            class="error"
            >Please enter allergy description.</span
          >
        </div>
        <hr />
      </ng-container>
      <app-arrow-link
        text="+ Add an Allergy"
        (handleClick)="addAllergy()"
      ></app-arrow-link>
    </div>
    <div *ngIf="editMode" style="margin-top: 5rem">
      <hr />
      <footer class="footer-action">
        <button
          type="button"
          class="btn btn-danger btn-block"
          (click)="onSave()"
          [disabled]="!form.valid"
        >
          Save
        </button>
      </footer>
    </div>
    <div *ngIf="!editMode">
      <span *ngIf="allergyFormArray.length === 0" class="lato"
        >No records found.</span
      >
      <ng-container
        *ngFor="let allergy of allergyFormArray.controls; let i = index"
      >
        <span class="lato bold title-red">{{ "Allergy " + (i + 1) }}</span>
        <div class="row">
          <div class="col view-container">
            <div class="view-label">Allergy Type</div>
            <span>{{ getAllergyDisplayType(allergy.value) }}</span>
            <hr class="view-divider" />
          </div>
        </div>
        <div class="row">
          <div class="col view-container">
            <div class="view-label">Allergy Description</div>
            <span>{{
              allergy.get("description").value
                ? allergy.get("description").value
                : "N/A"
            }}</span>
            <hr class="view-divider" />
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</form>
